var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrenamientoFuerza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.289,
    height: 24.066,
    viewBox: "0 0 32.289 24.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7182",
    "data-name": "Path 7182",
    d: "M32.3,7.921c-.039.213-.076.429-.115.642a7.26,7.26,0,0,1-6.48,6.018.718.718,0,0,0-.494.28c-1.071,1.186-2.128,2.4-3.258,3.544a22.278,22.278,0,0,1-4.952,3.6,19.2,19.2,0,0,1-4.355,1.963,1,1,0,0,1-.8-.076A22.741,22.741,0,0,1,2.78,15.06a21.064,21.064,0,0,1-2.4-5.838,9.483,9.483,0,0,1-.3-3.365A6.328,6.328,0,0,1,3.789.628a6.531,6.531,0,0,1,8.973,3.5,6.393,6.393,0,0,1,.053,4.739c-.059.16-.121.28.059.432a6.138,6.138,0,0,1,2.218,4.487c0,.07.02.143.031.238l2.675-.749a.488.488,0,0,0,.191-.1c.449-.409.895-.824,1.338-1.234-.28-.44-.561-.841-.791-1.293a7.291,7.291,0,1,1,13.74-4.15,1.1,1.1,0,0,0,.053.21ZM10.2,9.766c.135-.222.28-.454.412-.69a4.8,4.8,0,0,0,.642-3.365,4.7,4.7,0,0,0-9.217-.135,7.167,7.167,0,0,0,.182,3.2A21.07,21.07,0,0,0,6.3,16.861a19.646,19.646,0,0,0,5.925,5.047.606.606,0,0,0,.457.045c.608-.227,1.217-.463,1.8-.746a24.693,24.693,0,0,0,8.513-6.657.856.856,0,0,0,.076-.115L20.659,13.28c-.5.463-1.038.967-1.587,1.453a1.4,1.4,0,0,1-.536.308c-1.632.468-3.27.911-4.907,1.371l-.841.224c.118-.628.233-1.2.328-1.778a4.156,4.156,0,0,0-1.368-4.01A15.984,15.984,0,0,0,10.2,9.766Zm14.789,2.953a5.4,5.4,0,1,0-3.831-1.6A5.4,5.4,0,0,0,24.986,12.719Z",
    transform: "translate(-0.04 0.043)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7183",
    "data-name": "Path 7183",
    d: "M79.527,18.937a2.664,2.664,0,1,1,2.706,2.639A2.672,2.672,0,0,1,79.527,18.937Zm1.89-.05a.778.778,0,1,0,.782-.78A.791.791,0,0,0,81.417,18.887Z",
    transform: "translate(-57.231 -11.534)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrenamientoFuerza);
export default __webpack_public_path__ + "static/media/Entrenamiento_fuerza.38f34a90928783795b540dda056e3d71.svg";
export { ForwardRef as ReactComponent };